'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var defaultOptions = {
  joinOutput: false,
  cleanup: {
    after: ['atomic'],
    types: ['unstyled'],
    trim: false,
    split: true
  }
};

exports.default = defaultOptions;


//////////////////
// WEBPACK FOOTER
// ./node_modules/redraft/lib/defaultOptions.js
// module id = 695
// module chunks = 0